var styles = {
  "Container": "_Container_803jc_1",
  "Title": "_Title_803jc_9",
  "Content": "_Content_803jc_16",
  "Link": "_Link_803jc_22"
};

export { styles as default };
